module.exports = __webpack_public_path__ + "img/banner_default.9b40c2b4.png";